import useTranslation from 'next-translate/useTranslation';

const Links = () => {
  useTranslation('common');

  return <div />;
};

export default Links;
